<template>
  <div id="codelosForm" class="form-builder-container w-100 h-100">
    <div
      ref="formContainer"
      class="form-builder-wrapper w-100 h-100 d-flex align-items-center flex-column"
      :class="{ 'preview-mode': isPreview }"
    >
      <!-- <div class="field-search-wrapper" v-if="elements.length && !isPreview">
        <input
          type="text"
          placeholder="Suche"
          class="search-text"
          v-model="searchFormElement"
          :disabled="isElSidebarEditorVisible"
        />
        <img src="../../assets/img/search-icon.svg" class="search-icon" />
      </div> -->
      <form
        ref="codelosFormRef"
        class="codelos-app w-100"
        :class="{ 'was-submitted': isformSubmitClicked }"
        @submit.prevent
        @dragleave="handleFormDragLeave"
        @dragover.prevent="handleAutoScroll"
      >
        <div
          class="form-item-wrapper"
          :class="getLayoutSpacingClass"
          :style="getLayoutStyle"
        >
          <FormBuilderTabs
            ref="formTabsRef"
            :tabStructure="tabStructure"
            :tabData="tabData"
            :mutableElements="mutableElements"
            :isPreview="isPreview"
            :isItemDragging="dragItemId !== null"
            :layoutSetting="layoutSetting"
            :brandedStyle="brandedStyle"
            :getElementsFilteredByTabs="getElementsFilteredByTabs"
            :getDraggedItemTabIndex="getDraggedItemTabIndex"
            :isElSidebarEditorVisible="isElSidebarEditorVisible"
            :resetFormError="resetFormError"
            :validateSidebarElementEditor="validateSidebarElementEditor"
            @toggleSettings="tabData.settingModalVisible = true"
            @onTabItemDrop="onItemDropInTab"
            @updateMutableElements="(el) => (mutableElements = el)"
            @setOverflowWrapperheight="setOverflowWrapperheight"
            @toggleElSidebarEditor="toggleElSidebarEditor"
          />
          <div
            class="tab-content-wrapper w-100 fancy-scroll"
            ref="formScrollRef"
            :style="tabContentOffsetStyle"
            @scroll.passive="showScrollbar"
            @mouseenter="setScrollHover(true)"
            @mouseleave="setScrollHover(false)"
          >
            <div
              class="tab-inner-container"
              :class="{ active: tabIndex == tabData.activeTabIndex }"
              v-for="(tab, tabIndex) in tabStructure.tabs"
              :key="`${tabIndex}-${tab.label}`"
              @dragleave="handleElementContainerDragLeave"
            >
              <div
                v-show="tabIndex == tabData.activeTabIndex"
                :id="`tabElementWrapper${tabIndex}`"
              >
                <div
                  v-if="
                    !isPreview &&
                    getElementsFilteredByTabs(tab).length === 0 &&
                    !isTabsHaveElements(tab)
                  "
                  class="tab-drop-zone position-relative"
                  :class="{
                    show: dragItemId !== null && tabData.dropZoneVisible,
                  }"
                  @dragover.prevent="tabData.dropZoneVisible = true"
                  @dragleave="tabData.dropZoneVisible = false"
                  @drop="onItemDropInTab(tabData.activeTabIndex)"
                ></div>
                <FormGridLayout
                  :tab="tab"
                  :tabIndex="tabIndex"
                  :elements="getElementList"
                  :currentScreen="currentScreen"
                  :responseData="responseData"
                  :tabStructure="tabStructure"
                  :tabData="tabData"
                  :isPreview="isPreview"
                  :isActivePropsElement="isActivePropsElement"
                  :draggable="!isPreview"
                  :dragItemId="dragItemId"
                  :brandedStyle="brandedStyle"
                  :dragOverIndex="dragOverIndex"
                  :dragPosition="dragPosition"
                  :isAskAiModalVisible="isAskAiModalVisible"
                  :disabled="tabIndex != tabData.activeTabIndex"
                  :isUserHasAccess="isUserHasAccess"
                  :elementsToHide="elementsToHide"
                  :isDragInsideGrid="isDragInsideGrid"
                  :singleInstanceElementTypes="singleInstanceElementTypes"
                  :layoutSetting="layoutSetting"
                  :formSettings="settings"
                  :brandedSubmitBtnStyle="brandedSubmitBtnStyle"
                  @onAddGridElement="onAddGridElement"
                  @removeElement="removeElement"
                  @duplicateElement="duplicateElement"
                  @insertNewElement="insertNewElement"
                  @editElement="onElementEdit"
                  @removeGridCol="onRemoveGridCol"
                  @dragstart="onDragStart"
                  @dragover="onDragOver"
                  @dragend="onDragEnd"
                  @drop="onDrop"
                  @setDragItemId="setDragItemId"
                  @showAddElementList="onShowAddElementList"
                  @tabButtonSubmit="handleSubmit"
                />

                <div class="tab-btn-container">
                  <div
                    class="position-absolute error-message-container"
                    v-show="error.visible && isPreview"
                  >
                    <p>Die folgenden Felder sind ungültig:</p>
                    <ul>
                      <li
                        v-for="(error, index) in error.messages"
                        :key="index"
                        @click.stop.prevent="onErrorElementClick(error)"
                      >
                        {{ error.label }}
                      </li>
                    </ul>
                  </div>
                  <button
                    v-if="tabStructure?.tabs?.length > 1 && isPrevBtnVisible"
                    :style="brandedPrevBtnStyle"
                    @click="onPrevButtonClick"
                    class="tab-btn prev navigation"
                    type="button"
                  >
                    Zurück
                  </button>
                  <button
                    v-if="tabIndex < tabStructure?.tabs?.length - 1"
                    :style="brandedSubmitBtnStyle"
                    @click="onNextButtonClick"
                    class="tab-btn next navigation"
                    id="submitBtn"
                    type="submit"
                  >
                    Weiter
                  </button>
                  <button
                    v-if="
                      isSubmitBtnVisible(tabIndex) && !tabHasSubmitButton(tab)
                    "
                    key="submitBtn"
                    :style="brandedSubmitBtnStyle"
                    @click="handleSubmit"
                    class="tab-btn next submit"
                    :class="{
                      'tab-visible': tabStructure?.tabs?.length > 1,
                      'w-100': layoutSetting?.spacing == 'largemargin',
                    }"
                    id="submitBtn"
                    type="submit"
                  >
                    {{ settings?.btnCaption || 'Starten' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div v-if="!isPreview" ref="addButton" class="add-button-wrapper">
        <PlusIconButton
          :disabled="isDisablePlusButton"
          @onClick.stop="() => toggleAddElementDropDown()"
        />
        <FormElementSelectionModal
          v-if="isAddElementListVisible"
          :elements="mutableElements"
          :singleInstanceElementTypes="singleInstanceElementTypes"
          :elementsToHide="elementsToHide"
          :isUserHasAccess="isUserHasAccess"
          :isNewFormElement="isNewFormElement"
          :isInsideGrid="getNewElementInSideGrid"
          @addElement="onAddElement"
          v-click-outside="closeAddElementDropDown"
        />
      </div>
    </div>

    <FormBuilderElementSidebarEditor
      v-if="isElSidebarEditorVisible && selectedElement && !isPreview"
      :key="selectedElement.id"
      ref="propsModal"
      :isCreateCustomDB="false"
      :element="selectedElement"
      :elements="elements"
      :existingNames="existingNames"
      :reservedElementKeys="reservedElementKeys"
      :isUserHasAccess="true"
      :typeList="typeList"
      @close="toggleElSidebarEditor"
      @changeElement="changeElement"
      @onFileChange="onFileChange"
    ></FormBuilderElementSidebarEditor>

    <TabSettingsModal
      v-if="!isPreview && tabData.settingModalVisible"
      :tabStructure="tabStructure"
      @toggleSettings="tabData.settingModalVisible = false"
    />
  </div>
</template>
<script>
import FormBuilderElementSidebarEditor from './FormBuilderElementSidebarEditor.vue';
import PlusIconButton from '../widgets/PlusIconButton.vue';
import FormElementSelectionModal from '@/components/FormBuilder/common/FormElementSelectionModal.vue';
import FormBuilderTabs from './FormBuilderTabs.vue';
import TabSettingsModal from './TabSettingsModal.vue';
import {
  checkboxElementValidation,
  isValidEmail,
  openInvalidToggleList,
  openParentToggleListById,
  moveElementInTabStructure,
  moveElementToTab,
  insertElementInTabStructure,
  insertGridInTabStructure,
  removeElementFromTabStructure,
  getNewFormElement,
  insertElementInGridStructure,
  duplicateElementInTabStructure,
  findElementLevelInTabStructure,
  findParentElementId,
  setDragItemImage,
  removeDragItemImage,
  getCurrentDateTimeValueByType,
  executeAIGeneratedStyle,
  removeAIGeneratedStyle,
  isValidOptionElement,
  createUnique,
  generateUUID,
} from '@/utils/helpers/FormBuilderHelper';
import { vueBasedDefaultProcessRunnerVersion } from '@/utils/constants/WorkFlowConstants.js';
import {
  debouncer,
  isHexTooLight,
  showToaster,
  hexToRgba,
} from '@/utils/helpers';

import {
  formBuilderV3Elements,
  FORM_VALIDATION_MODES,
} from '@/utils/constants/FormBuilderConstants.js';
import { generateStructureObject } from '@/utils/helpers/WorkFlowHelpers';

import FormGridLayout from '@/components/FormBuilder/FormGridLayout.vue';

export default {
  name: 'FormBuilderV3',
  data() {
    return {
      formData: {},
      selectedElement: null,
      dragItemId: null,
      reservedElementKeys: [
        'id',
        'created',
        'updated',
        'owner',
        'automatedaicss',
        'codelosKanbanOrder',
        'style',
        'cdlsflowid',
      ],
      singleInstanceElementTypes: ['resultframe'],
      typeList: formBuilderV3Elements,
      isElSidebarEditorVisible: false,
      isAddElementListVisible: false,
      isformSubmitClicked: false,
      searchFormElement: '',
      dropDownTop: 200,
      mutableElements: [],
      isNewFormElement: {
        id: null,
        position: null, // "top", "bottom", null
        level: 0,
        rowIndex: null,
      },
      dragOverIndex: {
        col: null,
        row: null,
      },
      isDragInsideGrid: false,
      dragPosition: null,
      tabData: {
        activeTabIndex: null,
        renameTabIndex: null,
        settingModalVisible: false,
        dropZoneVisible: false,
      },
      autoScroll: {
        interval: null,
        direction: null, // "up", "down", or null
      },
      addElementIndex: {
        row: null,
        col: null,
      },
      error: {
        messages: [],
        visible: false,
      },
      tabHeaderHeight: 0,
      isMigratingLegacyNavButtons: false,
    };
  },
  props: {
    brandedStyle: { type: Object, default: () => {} },
    responseData: {
      type: Object,
      default: () => ({
        responsePayload: null,
        responseType: null,
        isLoading: false,
      }),
    },
    elements: {
      type: Array,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    elementInputs: {
      type: Array,
      required: false,
      deafult: [],
    },
    selectedDatabase: {
      type: Object,
      default: () => null,
    },
    elementsToHide: {
      type: Array,
      default: () => [],
    },
    elsToShow: {
      type: Array,
      default: () => [],
    },
    isUserHasAccess: { type: Boolean, default: true },
    settings: {
      type: Object,
      default: () => {},
      required: false,
    },
    currentScreen: {
      type: String,
      default: () => 'desktop',
      required: false,
    },
    isPreview: {
      type: Boolean,
      default: () => false,
    },
    processID: {
      type: [String, Number],
      default: () => '',
      required: false,
    },
    version: {
      type: String,
      default: () => vueBasedDefaultProcessRunnerVersion,
    },
    isAskAiModalVisible: {
      type: Boolean,
      default: () => false,
    },
    tabStructure: {
      type: Object,
      default() {
        return {
          tabs: [],
          layout: {},
        };
      },
      required: false,
    },
    flowSettings: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  methods: {
    handleSubmit(e) {
      e?.preventDefault?.();
      this.isformSubmitClicked = true;
      if (!this.handleFormError()) return;
      if (this.hasCustomValidationErrors(this.mutableElements)) return;
      if (!this.isPreview) {
        this.isformSubmitClicked = false;
        this.resetFormError();
        return;
      }
      this.syncFormValuesFromDom();
      const submission = {};
      this.mutableElements.forEach((element) => {
        if (element?.settings?.layoutItem) return;
        if (element.type === 'file') {
          submission[element.name] =
            element.files.length > 0 ? element.files : null;
        } else if (element.type === 'formatted_number') {
          submission[element.name] = this.parseFormattedNumberValue(
            element.value,
            element.settings
          );
        } else {
          submission[element.name] = element.value;
        }
      });
      if (this.flowSettings?.addAuthorizationToken) {
        const userName = localStorage.getItem(
          'CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.LastAuthUser'
        );
        const token = localStorage.getItem(
          'CognitoIdentityServiceProvider.61nps3sbkg5vcrn4vl5hduqbf4.' +
            userName +
            '.accessToken'
        );
        if (token) submission['authorization'] = 'Bearer ' + token;
        else submission['authorization'] = 'Bearer ';
      }
      submission['id'] = this.processID;
      this.formData = submission;
      this.$emit('handleSubmit', submission);
      this.isformSubmitClicked = false;
    },
    syncFormValuesFromDom() {
      const formRef = this.$refs.codelosFormRef;
      if (!formRef?.elements) return;
      Array.from(formRef.elements).forEach((control) => {
        const name = control?.name;
        if (!name) return;
        const element = this.mutableElements.find((el) => el.name === name);
        if (!element || element?.settings?.layoutItem) return;
        if (control.type === 'file') {
          element.files = control.files;
        } else if (control.type === 'checkbox') {
          element.value = control.checked ? control.value || true : '';
        } else if (control.type === 'radio') {
          if (control.checked) element.value = control.value;
        } else if (element.type === 'select') {
          const selectedOption = (element.options || []).find(
            (option) => option.label === control.value
          );
          element.value = selectedOption ? selectedOption.value : element.value;
        } else if (element.type === 'formatted_number') {
          element.value = this.parseFormattedNumberValue(
            control.value,
            element.settings
          );
        } else {
          element.value = control.value;
        }
      });
    },
    parseFormattedNumberValue(value, settings = {}) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value === 'number' && Number.isFinite(value)) return value;

      const thousandSeparator = settings?.thSep || '.';
      const decimalSeparator = settings?.decSep || ',';
      const escapeRegExp = (str) =>
        String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      const normalized = String(value)
        .trim()
        .replace(/\s/g, '')
        .replace(new RegExp(escapeRegExp(thousandSeparator), 'g'), '')
        .replace(new RegExp(escapeRegExp(decimalSeparator), 'g'), '.')
        .replace(/[^0-9.-]/g, '');

      if (!normalized || ['-', '.', '-.'].includes(normalized)) return '';

      const parsedValue = Number(normalized);
      return Number.isFinite(parsedValue) ? parsedValue : '';
    },
    onElementEdit(element) {
      if (this.isPreview || this.isAskAiModalVisible) return;
      if (
        this.isElSidebarEditorVisible &&
        (this.selectedElement?.name || !this.selectedElement?.name)
      ) {
        this.$refs.propsModal.formSubmit(element);
      } else {
        this.changeElement(element);
        this.isElSidebarEditorVisible = true;
      }
      this.setFileInputs();
    },
    validateSidebarElementEditor() {
      if (!this.isElSidebarEditorVisible) return true;
      const sidebarEditorRef = this.$refs.propsModal;
      return sidebarEditorRef.validateForm();
    },
    toggleElSidebarEditor() {
      this.isElSidebarEditorVisible = !this.isElSidebarEditorVisible;
      if (!this.isElSidebarEditorVisible) {
        this.setFileInputs();
      }
    },
    changeElement(element) {
      this.selectedElement = element;
    },
    onFileChange(element) {
      if (element.type === 'file') {
        const dataTransfer = new DataTransfer();
        if (element?.files?.length) {
          dataTransfer.items.add(element?.files[0]);
        }
        const fileElement = document.getElementById(`input-${element.id}`);
        if (dataTransfer.files && fileElement)
          fileElement.files = dataTransfer.files;
      }
    },
    setFileInputs() {
      const fileElements = this.elements.filter(
        (element) => element.type == 'file'
      );

      this.$nextTick(() => {
        fileElements.forEach((element) => {
          this.onFileChange(element);
        });
      });
    },
    getScrollContainer() {
      return this.$refs.formScrollRef || this.$refs.codelosFormRef;
    },
    toggleAddElementDropDown() {
      if (!this.formValidation()) return;

      this.isAddElementListVisible = !this.isAddElementListVisible;
    },
    closeAddElementDropDown() {
      this.isAddElementListVisible = false;
      this.isNewFormElement = {
        id: null,
        position: null,
        level: 0,
        rowIndex: null,
      };

      this.addElementIndex = {
        row: null,
        col: null,
      };
    },
    getDefaultNavButtonsElementId(tabIndex) {
      const tab = this.tabStructure?.tabs?.[tabIndex];
      const rows = tab?.rows || [];
      if (!rows.length) return null;

      const lastRow = rows[rows.length - 1];
      if (!lastRow?.cols?.length || lastRow.cols.length !== 1) return null;

      const [lastCol] = lastRow.cols;
      const elementId = lastCol?.elementId;
      if (!elementId || lastCol?.childs?.length) return null;

      const element = this.mutableElements.find((el) => el.id === elementId);
      return element?.type === 'navButtons' ? elementId : null;
    },
    onRemoveGridCol(rowIndex, colIndex) {
      const tabs = JSON.parse(JSON.stringify(this.tabStructure.tabs));
      const activeTab = tabs[this.tabData.activeTabIndex];

      const currentActiveRow = activeTab.rows[rowIndex];
      currentActiveRow.cols.splice(colIndex, 1);
      // Remove row if no columns left
      if (currentActiveRow.cols.length === 0) {
        activeTab.rows.splice(rowIndex, 1);
      }
      this.$set(this.tabStructure, 'tabs', tabs);
    },
    onAddGridElement(elementDefaults, rowIndex, colIndex) {
      const finalElement = getNewFormElement(elementDefaults, [
        ...(this.elementInputs || []),
        ...this.elements,
      ]);
      this.mutableElements.push(finalElement);
      this.selectedElement = finalElement;

      const updatedTabList = insertElementInGridStructure({
        tabStructure: this.tabStructure.tabs,
        targetTabIndex: this.tabData.activeTabIndex,
        newElementId: finalElement.id,
        rowIndex: rowIndex,
        colIndex: colIndex,
        withChildContainer: finalElement.type === 'togglelist',
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
    },

    addSingleElement(elementDefaults) {
      const finalElement = getNewFormElement(elementDefaults, [
        ...(this.elementInputs || []),
        ...this.elements,
      ]);
      // Push new element to flow
      this.mutableElements.push(finalElement);
      this.selectedElement = finalElement;

      const referenceElementIndex = this.mutableElements.findIndex(
        (el) => el.id == this.isNewFormElement.id
      );

      if (referenceElementIndex > -1) {
        this.insertElementInTabStructure({
          newElement: finalElement,
          toElementId: this.isNewFormElement.id,
          position: this.isNewFormElement.position,
        });
      } else {
        const defaultNavButtonsElementId =
          finalElement.type !== 'navButtons'
            ? this.getDefaultNavButtonsElementId(this.tabData.activeTabIndex)
            : null;

        if (defaultNavButtonsElementId) {
          this.insertElementInTabStructure({
            newElement: finalElement,
            toElementId: defaultNavButtonsElementId,
            position: 'top',
          });
        } else {
          this.insertElementInTabStructure({ newElement: finalElement });
        }
        this.$nextTick(() => {
          const container = this.getScrollContainer();
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });
      }
      this.isNewFormElement = {
        id: null,
        position: null,
        level: 0,
        rowIndex: null,
      };
    },

    onShowAddElementList(rowIndex, colIndex) {
      this.addElementIndex = {
        row: rowIndex,
        col: colIndex,
      };
      this.toggleAddElementDropDown();
    },
    // hadnle on grid add
    handleGridElements(elementDefaults, rowIndex, position) {
      const updatedTabList = insertGridInTabStructure({
        tabStructure: this.tabStructure.tabs,
        targetTabIndex: this.tabData.activeTabIndex,
        gridLayout: elementDefaults.gridStructure,
        rowIndex: rowIndex,
        position: position,
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
    },
    isOneTimeElementAlreadyExists(elementDefaults) {
      const elementType = elementDefaults?.type || elementDefaults?.name;
      if (
        !elementType ||
        !this.singleInstanceElementTypes.includes(elementType)
      ) {
        return false;
      }

      return this.mutableElements.some(
        (element) => element.type === elementType
      );
    },

    onAddElement(elementDefaults) {
      if (this.isOneTimeElementAlreadyExists(elementDefaults)) {
        showToaster(
          this,
          'Dieses Element kann nur einmal hinzugefugt werden.',
          'Fehlerhaft !',
          'danger'
        );
        this.closeAddElementDropDown();
        return;
      }

      if (
        this.addElementIndex.row !== null &&
        this.addElementIndex.col !== null
      ) {
        this.onAddGridElement(
          elementDefaults,
          this.addElementIndex.row,
          this.addElementIndex.col
        );
      } else if (elementDefaults?.type == 'grid') {
        this.handleGridElements(
          elementDefaults,
          this.isNewFormElement.rowIndex,
          this.isNewFormElement.position
        );
      } else {
        this.addSingleElement(elementDefaults);
      }
      this.closeAddElementDropDown();
    },
    getImgUrl(img) {
      const images = require.context('@/assets/img/', false, /\.svg$/);
      return images(img);
    },
    getParentToggleList(elementId) {
      const parentId = findParentElementId(
        this.tabStructure.tabs[this.tabData.activeTabIndex],
        elementId
      );
      return this.elements.find(
        (el) => el.type === 'togglelist' && el.id === parentId
      );
    },
    hasCustomValidationErrors(formElements) {
      if (!formElements?.length) return false;
      return formElements.some((element) => {
        if (
          element.type === 'checkbox' &&
          element.settings.required &&
          !element.settings.disabled
        ) {
          const isValid = checkboxElementValidation(this, element, true, true);
          if (!isValid) {
            const parentElement = this.getParentToggleList(element.id);
            if (parentElement)
              openParentToggleListById(element.id, parentElement.id);
          }
          return !isValid;
        } else if (
          element.type === 'radio' &&
          element.settings.required &&
          !element.settings.disabled &&
          !element.value
        ) {
          showToaster(
            this,
            `${element.label} ist erforderlich. Bitte wählen Sie eine Option aus.`,
            'Fehlerhaft !',
            'danger'
          );
          const parentElement = this.getParentToggleList(element.id);
          if (parentElement)
            openParentToggleListById(element.id, parentElement.id);

          return true;
        }
      });
    },
    formValidation() {
      if (
        !this.isValidSelectedElementName() ||
        (this.isElSidebarEditorVisible && !this.isValidSelectedElementValue())
      ) {
        return false;
      } else if (
        this.isElSidebarEditorVisible &&
        this.selectedElement.type === 'number'
      ) {
        return this.numberElementValidation(this.selectedElement);
      } else if (
        this.isElSidebarEditorVisible &&
        ['checkbox', 'radio'].includes(this.selectedElement.type) &&
        !isValidOptionElement(this, this.selectedElement, false)
      ) {
        return false;
      }

      if (
        this.selectedElement?.settings?.appearance === 'card' &&
        this.selectedElement?.options?.length
      ) {
        const invalidCardOption = this.selectedElement.options.find(
          (op) =>
            op.isModalVisible && !op?.modalConfig?.modalLink?.trim()?.length
        );
        if (invalidCardOption) {
          return false;
        }
        return true;
      }
      return true;
    },
    numberElementValidation(element) {
      const min = Number(element.settings.min) || '';
      const max = Number(element.settings.max) || '';
      const isValidNameAndLabel =
        this.isValidSelectedElementName() && this.isValidSelectedElementValue();

      if (min !== '' && max !== '' && min >= max) return false;

      if (element.settings.required && element.value !== 0 && !element.value)
        return false;

      if (!element.settings.required && element.value !== 0 && !element.value)
        return isValidNameAndLabel;
      const value = Number(element.value);

      const isWithinRange =
        (min === '' || value >= min) && (max === '' || value <= max);

      return isWithinRange && isValidNameAndLabel;
    },
    isValidSelectedElementName() {
      return !(
        this.selectedElement?.name === '' ||
        this.existingNames
          .concat(this.reservedElementKeys)
          .filter((e) => e === this.selectedElement?.name).length > 1 ||
        !/^[a-z0-9äöü]+$/.test(this.selectedElement?.name)
      );
    },
    isValidSelectedElementValue() {
      const isElementValueRequired = this.selectedElement?.settings?.required;

      if (
        [
          'text',
          'number',
          'formatted_number',
          'date',
          'time',
          'datetime-local',
          'textarea',
          'hidden',
        ].includes(this.selectedElement.type) &&
        isElementValueRequired
      ) {
        if (!this.selectedElement.value) return false;
        if (
          this.selectedElement.type === 'text' &&
          this.selectedElement?.settings?.pattern
        ) {
          const pattern = new RegExp(this.selectedElement.settings.pattern);
          return pattern?.test(this.selectedElement?.value);
        }
        return true;
      } else if (
        this.selectedElement.type == 'file' &&
        isElementValueRequired
      ) {
        return this.selectedElement?.files?.length ? true : false;
      } else if (this.selectedElement.type == 'email') {
        if (!isElementValueRequired) {
          return this.selectedElement.value
            ? isValidEmail(this.selectedElement.value)
            : true;
        } else {
          return !this.selectedElement.value
            ? false
            : isValidEmail(this.selectedElement.value);
        }
      }

      return true;
    },
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    setScrollHover(isHovering) {
      const el = this.$refs.formScrollRef;
      if (!el) return;
      if (isHovering) {
        el.classList.add('show-scrollbar');
      } else {
        el.classList.remove('show-scrollbar');
      }
    },
    updateMutableElements() {
      // eslint-disable-next-line no-undef
      this.mutableElements = structuredClone(this.elements);
      const elementTypesToHide = ['model', 'model-database-id'];
      if (this.isPreview) {
        this.mutableElements = this.mutableElements.map((el) => {
          const shouldBeHidden = elementTypesToHide.includes(el.type);

          if (shouldBeHidden) {
            el.type = 'hidden';
            el.settings = el.settings || {};
            el.settings.default = true;
          }
          if (
            ['date', 'datetime-local', 'time'].includes(el.type) &&
            el.settings.todayAsDefaultValue
          ) {
            el.value = getCurrentDateTimeValueByType(el.type);
          } else if (el.type == 'toggleswitch') {
            const isPrefilled =
              typeof el?.settings?.prefilled === 'boolean'
                ? el.settings.prefilled
                : el.settings.default;
            el.value = isPrefilled ? el.value : false;
          } else if (el.type == 'radio' && !el.settings.prefilled) {
            el.value = '';
            el.options.forEach((op) => (op.checked = false));
          } else {
            el.value =
              el.settings.default === true ||
              [
                'file',
                'radio',
                'checkbox',
                'filenew',
                'hidden',
                'html',
                'toggleswitch',
              ].includes(el.type)
                ? el.value
                : '';
          }
          return el;
        });
      }
    },
    isActivePropsElement(element) {
      return (
        this.isElSidebarEditorVisible &&
        element?.id === this.selectedElement?.id &&
        element?.name === this.selectedElement?.name
      );
    },
    removeElement(element) {
      if (!element) return;
      if (this.selectedElement && this.selectedElement.id == element.id) {
        this.isElSidebarEditorVisible = false;
        this.selectedElement = null;
      }

      const { updatedTabList, removedElementIds } =
        removeElementFromTabStructure({
          tabStructure: this.tabStructure.tabs,
          targetTabIndex: this.tabData.activeTabIndex,
          elementIdToRemove: element.id,
        });

      if (removedElementIds.length) {
        if (updatedTabList)
          this.$set(this.tabStructure, 'tabs', updatedTabList);

        this.mutableElements = this.mutableElements.filter((el) => {
          return !removedElementIds.includes(el.id);
        });
      }
    },
    duplicateElement(element) {
      if (!element) return;
      const { updatedTabList, updatedElementList } =
        duplicateElementInTabStructure({
          tabList: this.tabStructure.tabs,
          elementList: this.elements,
          activeTabIndex: this.tabData.activeTabIndex,
          elementIdToDuplicate: element.id,
        });

      this.$emit('saveElements', updatedElementList);
      this.$set(this.tabStructure, 'tabs', updatedTabList);
      this.mutableElements = updatedElementList;
    },
    insertNewElement(elementId, type, rowIndex) {
      if (!elementId) return;
      this.isNewFormElement.level =
        findElementLevelInTabStructure(
          this.tabStructure.tabs[this.tabData.activeTabIndex],
          elementId
        ) || 0;
      this.isNewFormElement.id = elementId;
      this.isNewFormElement.position = type;
      this.isNewFormElement.rowIndex = rowIndex;
      this.toggleAddElementDropDown();
    },
    insertElementInTabStructure({ newElement, toElementId, position }) {
      const elementTypesWithChild = ['togglelist', 'wrapper'];
      const updatedTabList = insertElementInTabStructure({
        tabStructure: this.tabStructure.tabs,
        targetTabIndex: this.tabData.activeTabIndex,
        newElementId: newElement.id,
        position,
        referenceElementId: toElementId,
        withChildContainer: elementTypesWithChild.includes(newElement.type),
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
    },
    setDragItemId(id) {
      if (this.dragItemId && id) return;
      this.dragItemId = id;
    },
    handleFormDragLeave(event) {
      const formWrapper = document.querySelector('.form-item-wrapper');
      if (!formWrapper.contains(event.relatedTarget)) this.dragPosition = null;
    },
    onDragStart(event, element) {
      this.setDragItemId(element.id);
      setDragItemImage(event);

      this.closeAddElementDropDown();
    },
    onDragOver(event, rowIndex, colIndex, element, isGridElement = false) {
      if (this.isPreview || !this.dragItemId) return;
      event.preventDefault();

      this.dragOverIndex.row = rowIndex;
      this.dragOverIndex.col = colIndex;
      this.isDragInsideGrid = isGridElement;

      const bounds = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const offsetTop = Math.round(mouseY - bounds.top);
      const height = bounds.height;

      // Special handling for togglelist
      if (
        offsetTop >= 27 + 12 &&
        offsetTop <= height - 17 &&
        ['togglelist'].includes(element.type)
      ) {
        this.dragPosition = null;
        return;
      }
      if (
        offsetTop >= 27 + 23 &&
        offsetTop <= height - 25 &&
        ['wrapper'].includes(element.type)
      ) {
        this.dragPosition = null;
        return;
      }

      const position = offsetTop <= height * 0.5 ? 'top' : 'bottom';

      if (
        this.getDragItemIndex === null ||
        (this.getDragItemIndex.row === null &&
          this.getDragItemIndex.col === null)
      ) {
        this.dragPosition = position;
      } else {
        const { row, col } = this.getDragItemIndex;
        const dragRow =
          this.tabStructure.tabs[this.tabData.activeTabIndex]?.rows?.[row];
        const isSingleColDragRow = dragRow?.cols?.length === 1;
        const currentRow =
          this.tabStructure.tabs[this.tabData.activeTabIndex]?.rows?.[rowIndex];
        const isSingleColDropRow = currentRow?.cols?.length === 1;
        // Hide dropzone on the dragged element itself (own place)
        if (rowIndex === row && colIndex === col) {
          // For multi-col rows, show dropzone only if in top 10% or bottom 10%
          if (!isSingleColDropRow) {
            // show dropzone on top 10% and bottom 10% for multicol layout
            if (offsetTop <= height * 0.1) {
              this.dragPosition = 'top';
            } else if (offsetTop >= height * 0.9) {
              this.dragPosition = 'bottom';
            } else {
              this.dragPosition = null;
            }
          } else {
            this.dragPosition = null;
          }
        }
        // Hide bottom dropzone on the element above (equivalent to top of dragged) only if single-col row
        else if (
          position === 'bottom' &&
          rowIndex === row - 1 &&
          ((isSingleColDropRow && isSingleColDragRow) ||
            (!isSingleColDropRow && isSingleColDragRow && !isGridElement)) // single drag multiple drop inside grid
        ) {
          this.dragPosition = null;
        }
        // Hide top dropzone on the element below (equivalent to bottom of dragged) only if single-col row
        else if (
          position === 'top' &&
          rowIndex === row + 1 &&
          ((isSingleColDropRow && isSingleColDragRow) ||
            (!isSingleColDropRow && isSingleColDragRow && !isGridElement)) // single drag multiple drop inside gird
        ) {
          this.dragPosition = null;
        } else {
          this.dragPosition = position;
        }
      }
    },
    onDrop(event, rowIndex, colIndex) {
      if (this.isPreview || !this.dragItemId || !this.dragPosition) return;

      event.stopPropagation();
      const updatedTabList = moveElementInTabStructure({
        data: this.tabStructure.tabs,
        dragId: this.dragItemId,
        // dropId: elementId,
        dropTabIndex: this.tabData.activeTabIndex,
        rowIndex: rowIndex,
        colIndex: colIndex,
        position: this.dragPosition,
        createNewRow: true,
        isDragInsideGrid: this.isDragInsideGrid,
      });
      if (updatedTabList) this.$set(this.tabStructure, 'tabs', updatedTabList);
      this.setDragItemId(null);
      this.onDragEnd();
    },

    onDragEnd() {
      this.stopAutoScroll();
      this.dragOverIndex = {
        row: null,
        col: null,
      };
      this.dragPosition = null;
      this.dragItemId = null;
      removeDragItemImage();
    },
    executeAiLogicScript() {
      if (!this.getAILogicList?.length) return;
      const doc = this.$el?.ownerDocument || document;
      const win = doc.defaultView || window;
      this.getAILogicList.forEach((aiItem) => {
        const code = aiItem?.code;
        if (!code || !this.isSafeAiLogicCode(code)) return;
        try {
          // Execute with a small allow-list API for form manipulation use-cases.
          const safeApi = {
            showElementById: (id) => {
              const el = doc.getElementById(id);
              if (el) el.style.display = '';
            },
            hideElementById: (id) => {
              const el = doc.getElementById(id);
              if (el) el.style.display = 'none';
            },
            setValueByName: (name, value) => {
              const formRef = this.$refs.codelosFormRef;
              const inputEl = formRef?.elements?.[name];
              if (inputEl) inputEl.value = value;
            },
          };

          const fn = new Function('ctx', 'document', 'window', 'api', code);
          fn.call(this, this, doc, win, safeApi);
        } catch (err) {
          console.error('Error executing ai script:', err);
        }
      });
    },
    isSafeAiLogicCode(code = '') {
      const blockedPatterns = [
        /\beval\s*\(/i,
        /\bnew\s+Function\b/i,
        /\bXMLHttpRequest\b/i,
        /\bfetch\s*\(/i,
        /\bWebSocket\b/i,
        /\bdocument\.cookie\b/i,
        /\blocalStorage\b/i,
        /\bsessionStorage\b/i,
        /\bwindow\.location\b/i,
        /\btop\b/i,
        /\bparent\b/i,
        /\bpostMessage\b/i,
        /\bimport\s*\(/i,
      ];
      return !blockedPatterns.some((pattern) => pattern.test(code));
    },
    mutateTabRowStructure({
      elementId,
      toElementId,
      position,
      tabIndex,
      action = 'insert', // 'insert', 'move'
    }) {
      try {
        const activeTabIndex = tabIndex
          ? tabIndex
          : this.tabData.activeTabIndex;

        const rows = JSON.parse(
          JSON.stringify(this.tabStructure.tabs[activeTabIndex].rows)
        );

        if (action == 'insert') {
          const row = generateStructureObject({}, 'row');
          row.cols.push(
            generateStructureObject({ elementId: elementId }, 'col')
          );
          if (toElementId && position) {
            const rowIndex = rows.findIndex((row) =>
              row.cols.find((col) => col.elementId == toElementId)
            );
            rows.splice(position == 'top' ? rowIndex : rowIndex + 1, 0, row);
          } else {
            rows.push(row);
          }
          this.tabStructure.tabs[activeTabIndex].rows = rows;
        }

        if (action == 'move') {
          if (elementId && toElementId && position) {
            const oldTabIndex = this.tabStructure.tabs.findIndex((tab) =>
              tab.rows.some((row) =>
                row.cols.some((col) => col.elementId === elementId)
              )
            );

            const newTabIndex = this.tabStructure.tabs.findIndex((tab) =>
              tab.rows.some((row) =>
                row.cols.some((col) => col.elementId === toElementId)
              )
            );

            if (oldTabIndex == newTabIndex) {
              const draggedRowIndex = rows.findIndex((row) =>
                row.cols.find((col) => col.elementId == elementId)
              );

              const dropRowIndex = rows.findIndex((row) =>
                row.cols.find((col) => col.elementId == toElementId)
              );

              const [draggedRow] = rows.splice(draggedRowIndex, 1);

              let insertIndex = dropRowIndex;
              if (draggedRowIndex < dropRowIndex) {
                insertIndex--;
              }

              if (position === 'bottom') {
                insertIndex++;
              }

              rows.splice(insertIndex, 0, draggedRow);
              this.tabStructure.tabs[activeTabIndex].rows = rows;
            } else {
              const oldRows = this.tabStructure.tabs[oldTabIndex].rows;

              const newRows = this.tabStructure.tabs[newTabIndex].rows;

              const draggedRowIndex = oldRows.findIndex((row) =>
                row.cols.find((col) => col.elementId == elementId)
              );

              const dropRowIndex = newRows.findIndex((row) =>
                row.cols.find((col) => col.elementId == toElementId)
              );

              const [draggedRow] = oldRows.splice(draggedRowIndex, 1);

              let insertIndex = dropRowIndex;

              if (position === 'bottom') {
                insertIndex++;
              }

              newRows.splice(insertIndex, 0, draggedRow);
            }
          }
        }
      } catch (error) {
        /* eslint-disable no-console */
        console.log('error :>> ', error);
      }
    },
    getElementsFilteredByTabs(tab) {
      const elements = [];
      tab?.rows?.forEach((row) => {
        row?.cols?.forEach((col) => {
          const colElement = this.mutableElements.find(
            (el) => el.id == col.elementId
          );

          if (colElement) {
            elements.push(colElement);
          }
        });
      });

      return elements;
    },
    isColsHaveElements(col) {
      return col.hasOwnProperty('elementId');
    },
    isTabsHaveElements(tab) {
      return tab?.rows[0]?.cols?.length;
    },
    tabHasSubmitButton(tab, elementList = this.mutableElements) {
      if ((this.tabStructure?.tabs?.length || 0) > 1) return false;
      if (!tab?.rows?.length) return false;
      const elementMap = new Map(
        (elementList || []).map((element) => [element.id, element])
      );
      const hasSubmitInCols = (cols = []) => {
        for (const col of cols) {
          if (!col) continue;
          if (
            col.elementId &&
            elementMap.get(col.elementId)?.type === 'navButtons'
          ) {
            return true;
          }
          if (col.childs?.length && hasSubmitInCols(col.childs)) {
            return true;
          }
        }
        return false;
      };

      return tab.rows.some((row) => hasSubmitInCols(row?.cols || []));
    },
    createLegacyNavButtonsElement(existingElements = []) {
      const existingNames = existingElements
        .map((element) => element?.name)
        .filter(Boolean);
      const existingLabels = existingElements
        .map((element) => element?.label)
        .filter(Boolean);

      return {
        id: generateUUID(),
        name: createUnique(existingNames, 'navButtons'),
        label: createUnique(existingLabels, 'Navigation'),
        type: 'navButtons',
        value: '',
        settings: {
          required: false,
          disabled: false,
          default: true,
          layoutItem: true,
        },
      };
    },
    migrateLegacySubmitButtons() {
      if (this.isPreview || this.isMigratingLegacyNavButtons) return;
      const tabs = this.tabStructure?.tabs;
      if (!Array.isArray(tabs) || tabs.length === 0) return;
      if (tabs.length > 1) return;

      const currentElements = JSON.parse(
        JSON.stringify(this.mutableElements || [])
      );
      const formAlreadyHasNavButtons = tabs.some((tab) =>
        this.tabHasSubmitButton(tab, currentElements)
      );
      if (formAlreadyHasNavButtons) return;

      const targetTabIndex = tabs.length - 1;
      const updatedTabs = JSON.parse(JSON.stringify(tabs));
      const navButtonElement =
        this.createLegacyNavButtonsElement(currentElements);
      currentElements.push(navButtonElement);

      const targetTab = updatedTabs[targetTabIndex];
      targetTab.rows = targetTab.rows || [];
      targetTab.rows.push({
        cols: [{ elementId: navButtonElement.id }],
      });

      this.isMigratingLegacyNavButtons = true;
      this.mutableElements = currentElements;
      this.$emit('saveElements', currentElements);
      this.$set(this.tabStructure, 'tabs', updatedTabs);
      this.$nextTick(() => {
        this.isMigratingLegacyNavButtons = false;
      });
    },

    onItemDropInTab(dropTabIndex = null) {
      if (this.dragItemId && dropTabIndex !== null) {
        const updatedTabList = moveElementToTab(
          this.tabStructure.tabs,
          this.dragItemId,
          dropTabIndex
        );
        if (updatedTabList)
          this.$set(this.tabStructure, 'tabs', updatedTabList);
        this.onDragEnd();
      }
    },
    onPrevButtonClick() {
      if (this.isPrevBtnVisible) {
        const tabsRef = this.$refs.formTabsRef;
        const activeTabIndex = this.tabData.activeTabIndex;
        if (activeTabIndex > -1) {
          this.tabData.activeTabIndex = activeTabIndex - 1;
          tabsRef.scrollTabToView(activeTabIndex - 1);
          this.resetFormError();
        }
      }
    },
    onNextButtonClick(e) {
      e.preventDefault();
      const activeTabIndex = this.tabData.activeTabIndex;
      const tabsRef = this.$refs.formTabsRef;
      const scrollContainer = this.getScrollContainer();
      this.isformSubmitClicked = true;
      if (!this.handleFormError()) return;

      if (
        this.hasCustomValidationErrors(
          this.getElementsFilteredByTabs(
            this.tabStructure?.tabs[activeTabIndex]
          )
        )
      )
        return;

      if (scrollContainer) {
        scrollContainer.scrollTop = 0;
      }

      if (activeTabIndex > -1) {
        this.tabData.activeTabIndex = activeTabIndex + 1;
        tabsRef.scrollTabToView(activeTabIndex + 1);
      }
      this.isformSubmitClicked = false;
      this.resetFormError();
    },
    isSubmitBtnVisible(tabIndex) {
      return (
        tabIndex == this.tabStructure?.tabs?.length - 1 ||
        this.tabStructure?.tabs?.length === 1
      );
    },
    handleAutoScroll(e) {
      if (this.dragItemId !== null && !this.isPreview) {
        const container = this.getScrollContainer();
        if (!container) return;
        const rect = container.getBoundingClientRect();
        const threshold = 70;
        const speed = 3;

        if (e.clientY < rect.top + threshold) {
          this.autoScroll.direction = 'up';
        } else if (e.clientY > rect.bottom - threshold) {
          this.autoScroll.direction = 'down';
        } else {
          this.autoScroll.direction = null;
        }

        if (!this.autoScroll.interval) {
          this.autoScroll.interval = setInterval(() => {
            if (this.autoScroll.direction === 'up') {
              container.scrollTop -= speed;
            } else if (this.autoScroll.direction === 'down') {
              container.scrollTop += speed;
            }
          }, 1);
        }
      }
    },
    stopAutoScroll() {
      this.autoScroll.direction = null;
      if (this.autoScroll.interval) {
        clearInterval(this.autoScroll.interval);
        this.autoScroll.interval = null;
      }
    },
    setOverflowWrapperheight(height) {
      const wrapper = this.$refs.overflowWrapperRef;
      this.tabHeaderHeight = height || 0;
      if (wrapper) wrapper.style.height = `${this.tabHeaderHeight}px`;
    },
    handleElementContainerDragLeave(e) {
      if (this.dragPosition !== null) {
        const wrapper = document.getElementById(
          `tabElementWrapper${this.tabData.activeTabIndex}`
        );
        if (wrapper) {
          if (wrapper.contains(e.relatedTarget)) return;
          this.dragPosition = null;
        }
      }
    },
    handleFormError() {
      try {
        this.error.messages = [];

        const formRef = this.$refs.codelosFormRef;
        const scrollContainer = this.getScrollContainer();
        const validationMode =
          this.flowSettings?.validationMode ||
          FORM_VALIDATION_MODES.JUMP_TO_INVALID;

        // Validate basic inputs
        const isBasicValidated = this.handleBasicInputErrors(
          validationMode,
          formRef,
          scrollContainer
        );

        // Validate checkbox and radio elements
        const isSpecialValidated = this.handleSpecialElementValidation(
          validationMode,
          formRef,
          scrollContainer,
          isBasicValidated
        );

        return isBasicValidated && isSpecialValidated;
      } catch (error) {
        console.error('Form Error:', error);
      }
    },
    handleBasicInputErrors(validationMode, formRef, scrollContainer) {
      const isFormValid = formRef.checkValidity();
      if (!isFormValid) {
        const activeTabElements = document.querySelectorAll(
          `#tabElementWrapper${this.tabData.activeTabIndex} input, select, textarea`
        );

        for (const input of activeTabElements) {
          if (!input.checkValidity()) {
            if (validationMode === FORM_VALIDATION_MODES.JUMP_TO_INVALID) {
              showToaster(
                this,
                input.validationMessage,
                'Fehlerhaft !',
                'danger'
              );
              this.$nextTick(() =>
                this.handleErrorScroll(scrollContainer || formRef, input)
              );
              return false;
            }
          }
        }

        if (validationMode === FORM_VALIDATION_MODES.ERROR_SUMMARY) {
          for (const input of activeTabElements) {
            if (!input.checkValidity()) {
              const element = this.mutableElements.find(
                (el) => el.name === input.getAttribute('name')
              );

              this.error.messages.push({
                element: input,
                label: element?.label?.trim() || input.getAttribute('name'),
                elementId: element.id,
              });
            }
          }
          if (this.error.messages.length > 0) {
            this.error.visible = true;
            this.setErrorContainerPosition();
            return false;
          }
        }
      }
      return true;
    },
    handleSpecialElementValidation(
      validationMode,
      formRef,
      scrollContainer,
      isBasicValidated = true
    ) {
      const tabElementsArr = this.getElementsFilteredByTabs(
        this.tabStructure.tabs[this.tabData.activeTabIndex]
      );
      if (tabElementsArr?.length > 0) {
        for (const element of tabElementsArr) {
          const isRequired =
            element.settings.required && !element.settings.disabled;
          const elementWrapper = document.getElementById(
            `form-element-${element.id}`
          );

          if (element.type === 'checkbox' && isRequired) {
            const showToaster =
              validationMode === FORM_VALIDATION_MODES.JUMP_TO_INVALID
                ? isBasicValidated
                : false;
            if (!checkboxElementValidation(this, element, showToaster, true)) {
              if (validationMode === FORM_VALIDATION_MODES.JUMP_TO_INVALID) {
                this.$nextTick(() =>
                  this.handleErrorScroll(
                    scrollContainer || formRef,
                    elementWrapper
                  )
                );
                return false;
              }

              if (validationMode === FORM_VALIDATION_MODES.ERROR_SUMMARY) {
                if (element?.label?.trim()) {
                  this.error.messages.push({
                    element: elementWrapper,
                    label: element.label,
                    meta: element,
                    elementId: element.id,
                  });
                }
              }
            }
          }

          if (element.type === 'radio' && isRequired && !element.value) {
            if (validationMode === FORM_VALIDATION_MODES.JUMP_TO_INVALID) {
              showToaster(
                this,
                `${element.label} ist erforderlich. Bitte wählen Sie eine Option aus.`,
                'Fehlerhaft !',
                'danger'
              );
              this.$nextTick(() =>
                this.handleErrorScroll(
                  scrollContainer || formRef,
                  elementWrapper
                )
              );
              return false;
            }
            if (validationMode === FORM_VALIDATION_MODES.ERROR_SUMMARY) {
              if (element?.label?.trim()) {
                this.error.messages.push({
                  element: elementWrapper,
                  label: element.label,
                  elementId: element.id,
                });
              }
            }
          }
        }

        if (this.error.messages.length > 0) {
          this.error.visible = true;
          this.setErrorContainerPosition();
          return false;
        }
      }

      const form = this.$refs.codelosFormRef;
      const isValidToggleList = openInvalidToggleList(form);

      return isValidToggleList;
    },
    handleErrorScroll(scrollContainer, element, elementId = null) {
      if (elementId) {
        const parentElement = this.getParentToggleList(elementId);
        if (parentElement) openParentToggleListById(null, parentElement.id);
      }
      setTimeout(() => {
        if (element && scrollContainer) {
          const formRect = scrollContainer.getBoundingClientRect();
          const tabListContainer = document.querySelector('.tab-list-wrapper');
          const tabListRect = tabListContainer?.getBoundingClientRect();
          const spaceAbove =
            (tabListRect?.top || 0) + (tabListRect.height || 0);
          const elRect = element.getBoundingClientRect();
          const offset =
            elRect.top -
            formRect.top +
            scrollContainer.scrollTop -
            spaceAbove -
            50;

          element?.reportValidity && element.reportValidity();

          scrollContainer.scrollTo({ top: offset, behavior: 'smooth' });
        }
      }, 200);
    },

    onErrorElementClick(error) {
      this.$nextTick(() => {
        const scrollContainer = this.getScrollContainer();

        if (error?.meta?.type === 'checkbox') {
          checkboxElementValidation(this, error.meta, true, true);
        }

        if (scrollContainer && error?.element) {
          this.handleErrorScroll(
            scrollContainer,
            error.element,
            error.elementId
          );
        }
        this.resetFormError();
      });
    },
    setErrorContainerPosition() {
      if (this.isPreview) {
        this.$nextTick(() => {
          const btnContainer = document.querySelector(
            `#tabElementWrapper${this.tabData.activeTabIndex} .tab-btn-container`
          );
          const nextBtn = document.querySelector(
            `#tabElementWrapper${this.tabData.activeTabIndex} .tab-btn.next`
          );
          const errorContainer = btnContainer.querySelector(
            `.error-message-container`
          );

          if (btnContainer && nextBtn && errorContainer) {
            const containerRect = btnContainer.getBoundingClientRect();
            const btnRect = nextBtn.getBoundingClientRect();
            const left = btnRect.left - containerRect.left;
            errorContainer.style.left = left + 'px';
          }
        });
      }
    },
    resetFormError() {
      this.error.messages = [];
      this.error.visible = false;
    },
  },
  computed: {
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    tabContentOffsetStyle() {
      if (
        !this.isPreview ||
        (this.tabStructure?.tabs?.length || 0) <= 1 ||
        this.tabHeaderHeight <= 0
      )
        return {};

      return {
        paddingTop: `${this.tabHeaderHeight}px`,
        marginTop: `-${this.tabHeaderHeight}px`,
      };
    },
    getElementList() {
      return this.isPreview ? this.mutableElements : this.elements;
    },
    isDisablePlusButton() {
      return this.isElSidebarEditorVisible && !this.formValidation();
    },

    existingNames() {
      return this.elements.map((e) => e.name);
    },
    existingLabels() {
      return this.elements.map((e) => e.label);
    },

    brandedPrevBtnStyle() {
      return {
        ...this.brandedSubmitBtnStyle,
        color: this.brandedStyle?.primaryBrandColor
          ? isHexTooLight(this.brandedStyle.primaryBrandColor)
            ? `#000`
            : `#fff`
          : `#000`,
      };
    },
    brandedSubmitBtnStyle() {
      return {
        fontFamily: this.brandedStyle?.fontType
          ? `${this.brandedStyle?.fontType} !important`
          : '',
        borderRadius:
          this.brandedStyle &&
          this.brandedStyle.hasOwnProperty('secondaryBordarRadius')
            ? `${this.brandedStyle?.secondaryBordarRadius}px`
            : '',
        backgroundColor: this.brandedStyle?.primaryBrandColor
          ? `${this.brandedStyle?.primaryBrandColor}`
          : '',
      };
    },
    brandedLabelStyle() {
      return {
        color: this.brandedStyle?.textColor
          ? `${this.brandedStyle?.textColor}`
          : '',
        fontFamily: this.brandedStyle?.fontType
          ? `${this.brandedStyle?.fontType}`
          : '',
      };
    },
    brandedFieldStyle() {
      return {
        // color: this.brandedStyle?.textColor
        //   ? `${this.brandedStyle?.textColor} `
        //   : '',
        placeholderColor: hexToRgba(this.brandedStyle?.textColor, 0.4),
        textColor: this.brandedStyle?.textColor,
        borderColor: this.brandedStyle?.primaryBrandColor
          ? `${this.brandedStyle?.primaryBrandColor}`
          : '',
        outlineColor: this.brandedStyle?.primaryBrandColor
          ? `${this.brandedStyle?.primaryBrandColor} `
          : '',
        borderRadius:
          this.brandedStyle &&
          this.brandedStyle.hasOwnProperty('primaryBordarRadius')
            ? `${this.brandedStyle?.primaryBordarRadius}px`
            : '',
        color: this.brandedStyle?.primaryBrandColor
          ? isHexTooLight(this.brandedStyle.primaryBrandColor)
            ? `#000`
            : `#fff`
          : ``,
      };
    },
    layoutSetting() {
      return this.settings.layout;
    },
    getLayoutStyle() {
      if (this.layoutSetting.spacing !== 'custom') {
        return {};
      } else {
        return {
          'padding-left':
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.left
              .value || 0) +
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.left
              .unit || 'px'),
          'padding-top':
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.top
              .value || 0) +
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.top
              .unit || 'px'),
          'padding-bottom':
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.bottom
              .value || 0) +
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.bottom
              .unit || 'px'),
          'padding-right':
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.right
              .value || 0) +
            (this.layoutSetting?.customSpacing?.[this.currentScreen]?.right
              .unit || 'px'),
        };
      }
    },
    getLayoutSpacingClass() {
      if (this.layoutSetting?.spacing == 'fullwidth') {
        return 'm-0 no-margin';
      } else if (this.layoutSetting?.spacing == 'largemargin') {
        return 'container-sm large-margin';
      } else if (this.layoutSetting?.spacing == 'standard') {
        return 'mx-3 standard-margin';
      } else {
        return 'custom';
      }
    },
    getDraggedItemTabIndex() {
      if (this.dragItemId) {
        return this.tabStructure.tabs.findIndex((tab) =>
          tab.rows.some((row) =>
            row.cols.some((col) => col.elementId === this.dragItemId)
          )
        );
      }

      return null;
    },
    getDragItemIndex() {
      const row = this.tabStructure.tabs[this.tabData.activeTabIndex].rows;
      // return row.findIndex((row) =>
      //   row.cols.find((col) => col.elementId == this.dragItemId)
      // );

      const rowIndex = row.findIndex((row) =>
        row.cols.find((col) => col.elementId === this.dragItemId)
      );
      if (rowIndex === -1) return null;
      const colIndex = row[rowIndex].cols.findIndex(
        (col) => col.elementId === this.dragItemId
      );
      return { row: rowIndex, col: colIndex };
    },
    isPrevBtnVisible() {
      return this.tabData.activeTabIndex > 0;
    },
    getAIStyles() {
      return (this.settings?.aiGenerated || [])
        .map((aiItem) => aiItem?.styles)
        .join('\n\n');
    },
    getAILogicCodes() {
      return (this.settings?.aiGenerated || [])
        .map((aiItem) => aiItem?.code)
        .join('\n\n');
    },
    getAILogicList() {
      return (this.settings?.aiGenerated || []).filter(
        (aiItem) => aiItem?.code?.trim()?.length
      );
    },
    getNewElementInSideGrid() {
      if (
        this.isNewFormElement.rowIndex == null &&
        this.addElementIndex.row == null
      ) {
        return false;
      }
      const rowIndex =
        this.addElementIndex.row == null
          ? this.isNewFormElement.rowIndex
          : this.addElementIndex.row;

      const currentTab = this.tabStructure?.tabs?.[this.tabData.activeTabIndex];
      const currentRow = currentTab?.rows?.[rowIndex];
      if (
        (currentRow?.cols?.length > 1 && !this.isNewFormElement.position) ||
        (this.isNewFormElement.position && this.isNewFormElement.level > 0)
      ) {
        return true;
      }
      return false;
    },
  },
  created() {
    this.updateMutableElements();
    this.migrateLegacySubmitButtons();
  },
  mounted() {
    this.setFileInputs();
    if (this.isPreview) {
      this.executeAiLogicScript();
    }
    executeAIGeneratedStyle(this.getAIStyles);
    this.tabData.activeTabIndex = 0;
    this.setErrorContainerPosition();
  },
  beforeDestroy() {
    this.stopAutoScroll();
    removeDragItemImage();
    removeAIGeneratedStyle(this.getAIStyles);
    if (this.removeScrollClass) {
      clearTimeout(this.removeScrollClass);
      this.removeScrollClass = null;
    }
  },
  watch: {
    mutableElements() {
      if (!this.isPreview) this.$emit('saveElements', this.mutableElements);
    },
    'tabStructure.tabs': {
      handler() {
        this.migrateLegacySubmitButtons();
      },
    },
  },
  components: {
    PlusIconButton,
    FormBuilderElementSidebarEditor,
    FormBuilderTabs,
    TabSettingsModal,
    FormElementSelectionModal,
    FormGridLayout,
  },
};
</script>

<style scoped>
.form-builder-container {
  padding: 10px 0;
}

.form-builder-container:has(.preview-mode) {
  padding: 0;
}

.form-builder-container
  .form-builder-wrapper:not(.preview-mode)
  .tab-inner-container.active {
  min-height: 195px;
}

.form-builder-container .field-search-wrapper {
  width: 70%;
  position: relative;
  margin: 10px auto;
  padding: 0 20px;
  padding-right: 87px;
}

.form-builder-container .field-search-wrapper .search-text {
  width: 100%;
  padding: 12px 30px;
  height: auto;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 3px;
  font-size: 13px;
  font-weight: 400;
  line-height: 14.18px;
  box-shadow: none;
  background: #fff;
}
.form-builder-container .field-search-wrapper .search-icon {
  position: absolute;
  left: 30px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.form-builder-container form.codelos-app {
  margin: 0 auto;
  min-height: 200px;
  display: flex;
  flex-direction: column;
}

.form-builder-container .preview-mode form.codelos-app {
  height: 100%;
}

.form-builder-container
  .form-builder-wrapper:not(.preview-mode)
  form.codelos-app {
  width: 100%;
  padding-top: 0;
}

.form-builder-container .preview-mode form.codelos-app .standard-margin,
.form-builder-container .preview-mode form.codelos-app .large-margin {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}
.form-builder-container .preview-mode form.codelos-app .no-margin {
  padding-top: 37px !important;
}
.form-builder-container form.codelos-app .form-item-wrapper {
  display: flex;
  flex-flow: column;
  flex: 1 1 auto;
  min-height: 0;
}

.form-builder-container form.codelos-app .tab-content-wrapper {
  flex: 1 1 auto;
  width: 100%;
  overflow: auto;
  min-height: 0;
}
.form-builder-container form.codelos-app .custom-btn {
  max-width: 100%;
  padding: 0;
  font-family: 'OpenSans-Bold';
  height: 65px;
  cursor: pointer;
  color: #ffffff;
  background-color: #000000;
  border: 0.5px solid #000000;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 700;
  line-height: 36px;
  transition: background-color 0.3s ease-in-out, border 0.3s ease-in-out;
}

.form-builder-container form.codelos-app .custom-btn.disabled {
  background-color: #6c757d;
}

.form-builder-container form.codelos-app .custom-btn.submit {
  margin-top: 11px;
}
.form-builder-container form.codelos-app .custom .custom-btn.submit {
  margin-bottom: 0px;
}
.form-builder-container
  form.codelos-app
  .form-item-wrapper.no-margin
  .custom-btn.submit,
.form-builder-container
  form.codelos-app
  .form-item-wrapper.standard-margin
  .custom-btn.submit {
  max-width: 383px;
}
.form-builder-container form.codelos-app .tab-btn-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  position: relative;
  margin-top: 15px;
}

.form-builder-container form.codelos-app .tab-btn-container .tab-btn {
  width: 221px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 0.5px solid;
  cursor: pointer;
  font-family: 'OpenSans-Bold';
  font-size: 16px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: -0.32px;
  position: relative;
  color: white;
}

.form-builder-container form.codelos-app .tab-btn-container .tab-btn.prev {
  border-color: #ddd;
  background: #fff;
}
.form-builder-container
  form.codelos-app
  .tab-btn-container
  .tab-btn.prev:hover {
  border-width: 2.2px;
  border-color: #000;
}

.form-builder-container form.codelos-app .tab-btn-container .tab-btn.next {
  color: #fff;
  border-color: #000;
  background: #000;
}

.form-builder-container form.codelos-app .no-margin .tab-btn-container .tab-btn,
.form-builder-container
  form.codelos-app
  .standard-margin
  .tab-btn-container
  .tab-btn {
  width: 383px;
}

.form-builder-container
  form.codelos-app
  .large-margin
  .tab-btn-container
  .navigation {
  width: 221px;
}

.form-builder-container
  form.codelos-app
  .custom
  .tab-btn-container
  .navigation {
  width: 50%;
  max-width: 383px;
}

.form-builder-container
  form.codelos-app
  .large-margin
  .tab-btn-container
  .submit.tab-visible {
  width: 221px;
}

.form-builder-container
  form.codelos-app
  .form-item-wrapper
  .submit-btn:disabled {
  background-color: #d8d8d8;
  border: 1px solid #d8d8d8;
  color: #868686;
}

.form-builder-container .add-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}
.form-builder-container .add-button-wrapper .form-element-drop-down * {
  box-sizing: border-box;
}

.form-builder-container .add-button-wrapper .form-element-drop-down {
  font-size: 14px;
  color: #4a556a;
  font-family: sans-serif;
  -webkit-font-smoothing: unset;
  padding: 11px;
  border-radius: 9px;
  box-shadow: 0 2px 8px rgb(31 37 50 / 18%);
  position: absolute;
  z-index: 100;
  width: 270px;
  list-style: none;
  background-color: #fff;
  overflow: hidden;
  border: none;
  left: 40%;
  right: 100%;
}
.form-builder-container .add-button-wrapper .form-element-drop-down img {
  background-color: #fefbfb;
  vertical-align: middle;
  border-style: none;
  width: 78px;
  height: 78px;
  padding: 13px;
  margin: 4px;
  border-radius: 5px;
  border: 1px solid #d2d0d0;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .form-element-search-wrapper {
  border: 1px solid #97979e;
  margin-left: 8px;
  padding: 2px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 36px;
  gap: 4px;
}
.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .form-element-search-wrapper
  input {
  width: 100%;
  outline: none;
  font-size: 14px;
  color: #4a556a;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .form-element-search-wrapper
  .search-icon {
  border: none !important;
  background: transparent !important;
  width: 24px !important;
  padding: 0 !important;
  margin: 0 !important;
  margin-left: 4px !important;
  height: 24px !important;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .element-list-wrapper {
  overflow: auto;
  max-height: calc(100vh - 420px);
  margin-block: 8px;
}

.form-builder-container .add-button-wrapper .form-element-drop-down .item {
  padding: 5px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
  transition: background 0.3s ease-in-out;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .item:hover {
  background: #f1efef;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .item.item-disabled {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
  cursor: not-allowed;
  opacity: 0.6;
}

.form-builder-container
  .add-button-wrapper
  .form-element-drop-down
  .item.item-disabled
  img {
  background: #e3e3e3fc !important;
  color: #a3a3a3;
}

/* Transition  animations */
.fade-move-enter-active,
.fade-move-leave-active {
  transition: all 0.2s ease;
}
.fade-move-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
.fade-move-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}
.fade-move-move {
  transition: transform 0.2s ease;
}

.mx-3 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}
.form-builder-wrapper .container-sm.large-margin {
  max-width: 530px;
  padding-left: 40px !important;
  padding-right: 40px !important;
  margin-left: unset !important;
  margin-right: unset !important;
}

.form-builder-container .form-item-wrapper .tab-drop-zone {
  height: 100px;
}

.form-builder-container .form-item-wrapper .tab-drop-zone::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #86c3f4;
  display: none;
}

.form-builder-container .form-item-wrapper .tab-drop-zone.show::before {
  display: block;
}

.form-builder-container
  form.codelos-app
  .tab-btn-container
  .error-message-container {
  border-radius: 7px;
  opacity: 1;
  background: #000000bd;
  -webkit-box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 0px 5px 3px rgba(0, 0, 0, 0.15);
  color: #e8e8e8;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 10px 20px;
  bottom: 70px;
  text-align: left;
  max-width: 400px;
  width: 400px;
  font-family: 'OpenSans-Regular';
  left: 0;
  cursor: default !important;
  z-index: 100;
}

.form-builder-container
  form.codelos-app
  .tab-btn-container
  .error-message-container
  ul {
  padding-left: 20px;
}

.form-builder-container
  form.codelos-app
  .tab-btn-container
  .error-message-container
  ul
  li {
  position: relative;
  cursor: pointer;
  width: fit-content;
  line-height: 21px;
  transition: all ease-in-out 200ms;
  text-decoration: none;
}

.form-builder-container
  form.codelos-app
  .tab-btn-container
  .error-message-container
  ul
  li:hover {
  text-decoration: underline;
}
@media screen and (min-width: 1366px) {
  .fancy-scroll.tab-content-wrapper::-webkit-scrollbar-thumb {
    display: none;
  }
  .fancy-scroll.tab-content-wrapper.show-scrollbar::-webkit-scrollbar-thumb {
    display: block;
  }
}

@media (min-width: 537px) {
  .form-builder-container
    .form-builder-wrapper.preview-mode
    .container-sm.large-margin {
    max-width: 450px;
  }
  .form-builder-container .form-builder-wrapper .container-sm.large-margin {
    max-width: 474px;
    padding-left: 0px !important;
    padding-right: 0px !important;
    margin-inline: auto !important;
  }
}

@media (min-width: 1080px) {
  .mx-3 {
    margin-left: 120px !important;
    margin-right: 120px !important;
  }
}
@media (min-width: 1200px) {
  .mx-3 {
    margin-left: 190px !important;
    margin-right: 190px !important;
  }
}
</style>
